module.exports = __webpack_public_path__ + "img/home-4-line-trans.ecb5ceb8.svg";